import { z } from 'zod';

import { getPassportDocSchema } from '@/pages/UserAccount/Profile';

import { confirmationOfApplicationSchema } from '@/features/ui/Steps/ConfirmationOfApplication/model/schemas';

import {
  zodArrayRequiredWithMinMax,
  zodCheckbox,
  zodEmail,
  zodPlaceholder,
  zodSelectOption,
  zodStringOptional,
  zodStringRequired,
  zodStringRequiredWithMinMax,
} from '@/shared/lib/validations';

import { DocumentTypeCode } from '@/api/types';

export const extractRedeliveryPersonalDataBaseSchema = z.object({
  lastName: zodStringRequired,
  firstName: zodStringRequired,
  middleName: zodStringOptional,
  email: zodEmail,
  phones: zodArrayRequiredWithMinMax(zodStringRequiredWithMinMax({ min: 13 }), { max: 1 }),
  extractRedeliveryDocument: zodSelectOption.extend({
    code: z.nativeEnum(DocumentTypeCode),
  }),
  documents: zodPlaceholder,
});

export const extractRedeliveryPersonalDataSchema = extractRedeliveryPersonalDataBaseSchema.superRefine((data, ctx) => {
  const documentType = data.extractRedeliveryDocument.code;
  const schemaByDocumentTypeCode = getPassportDocSchema(documentType);
  const result = schemaByDocumentTypeCode?.safeParse(data.documents[documentType]);

  if (!result?.success) {
    result?.error.issues.forEach((issue) => {
      ctx.addIssue({
        ...issue,
        path: ['documents', documentType, ...issue.path],
      });
    });
  }
});

export const deliveryAddressSchema = z.object({
  deliveryType: zodSelectOption,
  indexNumber: zodStringRequired,
  region: zodSelectOption,
  district: zodSelectOption,
  city: zodSelectOption,
  street: zodSelectOption,
  warehouse: zodSelectOption,
  building: zodStringOptional,
  apartment: zodStringOptional,
  agreement: zodCheckbox,
});

export const extractRedeliveryMergedSchema = extractRedeliveryPersonalDataBaseSchema
  .merge(deliveryAddressSchema)
  .merge(confirmationOfApplicationSchema);
